import { createContext } from "react";

export const TaskDetailsModalContext = createContext();
